import React from 'react';
import useWatchBreakpoint from './useWatchBreakpoint';

const BREAKPOINT_ORDER = {
  xxxs: 0,
  xxs: 1,
  xs: 2,
  sm: 3,
  md: 4,
  lg: 5,
  xlg: 6,
  xxlg: 7,
};

const compareBreakpoint = (a: Breakpoints, b: Breakpoints) => {
  const aI = BREAKPOINT_ORDER[a];
  const bI = BREAKPOINT_ORDER[b];
  if (aI === bI) {
    return 0;
  } else if (aI > bI) {
    return 1;
  } else {
    return -1;
  }
};

const getMatchedBreakpoint = (
  breakpointMatcher: BreakpointProps,
  breakpoint: Breakpoints
) => {
  const { widerThan, narrowerThan, at } = breakpointMatcher;
  if (widerThan !== undefined) {
    return compareBreakpoint(breakpoint, widerThan) >= 0;
  } else if (narrowerThan !== undefined) {
    return compareBreakpoint(breakpoint, narrowerThan) < 0;
  } else if (at !== undefined) {
    return compareBreakpoint(breakpoint, at) === 0;
  }
  return false;
};

export type Breakpoints =
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xlg'
  | 'xxlg';

export type ResponsiveSizes = Exclude<Breakpoints, 'xxlg'>;

type BreakpointProps = {
  /** Show contents at specific breakpoint  */
  at?: Breakpoints;
  /** Show contents at and narrower than specified breakpoints */
  narrowerThan?: Breakpoints;
  /** Show contents at and wider than specified breakpoints */
  widerThan?: Breakpoints;
};

const Breakpoint: React.FunctionComponent<BreakpointProps> = (props) => {
  const { children } = props;
  const breakpoint = useWatchBreakpoint();
  const show = getMatchedBreakpoint(props, breakpoint);

  return <>{show ? <>{children}</> : null}</>;
};

export default Breakpoint;
